/*
 * @Description:
 * @Autor: xiaona.wang
 * @Date: 2021-07-22 17:11:59
 * @LastEditors: xiaona.wang
 * @LastEditTime: 2021-07-30 18:10:31
 */
const getDefaultState = () => ({
  cacheViews: []
});

const state = getDefaultState();

const mutations = {
  SET_CACHE_VIEW: (state, data) => {
    // console.log(data)
    const tmp = data.map(item => item.name);
    // console.log(tmp)
    state.cacheViews = tmp;
  },
  ADD_CACHE_VIEW: (state, name) => {
    state.cacheViews.push(name);
    // localStorage.setItem('cacheViews', JSON.stringify(state.cacheViews))
  },
  DELETE_CACHE_VIEW: (state, name) => {
    console.log(state.cacheViews);
    const index = state.cacheViews.findIndex(item => item === name) || -1;
    if (index >= 0) {
      state.cacheViews.splice(index, 1);
    }
  }
  // INIT_CACHE_VIEW: (state) => {

  // }
};

const actions = {
  addCacheView({ commit, state }, name) {
    commit("ADD_CACHE_VIEW", name);
  },
  deleteCacheView({ commit, state }, name) {
    commit("DELETE_CACHE_VIEW", name);
  },
  setCacheView({ commit, state }, data) {
    // console.log(data)
    commit("SET_CACHE_VIEW", data);
  }

  /*
   * initViews({commit, state}) {
   *   commit('INIT_CACHE_VIEW)')
   * }
   */
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
